<template>
  <div class="d-flex topbar">
    <div class="d-flex justify-space-between align-center topbar-top-row">
      <div class="topbar-breadcrumbs">
        <slot name="breadcrumbs" />
      </div>
      <div class="topbar-summaries">
        <slot name="summaries" />
      </div>
    </div>
    <div class="d-flex justify-space-between align-center topbar-bottom-row">
      <div class="topbar-page-title">
        <slot name="page-title" />
      </div>
      <div class="topbar-actions">
        <slot name="topbar-actions" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.topbar {
  flex-direction: column;
  position: sticky;
  top: 0;
  z-index: 3;
  background: @bg-canvas;
}

.topbar-top-row {
  margin-top: 16px;
  margin-bottom: 24px;
}

.topbar-bottom-row {
  margin-bottom: 24px;
}
</style>
